import PRE_COMPLETION_CONFIG from "../config/preCompletionConfig";
import ChecklistPage from "./ChecklistPage";

export default function PreCompletionChecklist() {
  return <ChecklistPage config={PRE_COMPLETION_CONFIG} checklistType="pre_completion" />;
}
